require('../../modules/es7.symbol.async-iterator');
module.exports = require('../../modules/_wks-ext').f('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/symbol/async-iterator.js
// module id = C01N
// module chunks = 0